import React from 'react'
import { useStyles } from './styles'
import { CollapseButton } from '../../../UI/CollapseButton/CollapseButton'
import { DetailsDocsMatchPutAway } from '../DocsMatchPutAway/DetailsDocsMatchPutAway'
import { usePutAway } from '../../Context/usePutAway'
import { putAwayActions as putAwayBusiness } from '../../actions/putAwayBusiness'
import { WorkOrderInBoundLocate } from '../../../../interfaces/WorkOrder/WorkOrder'
import { WithoutResultsPanel } from '../../../UI/GenericMessages/WithoutResultsPanel'

export const DocsMatchUnknowPutAway = () => {
  const classes = useStyles()
  const { state } = usePutAway()

  const { getWorkOrderLocateUnknown } = putAwayBusiness()
  const { workOrderInboundLocate } = state

  const handleCollapseClick = (workOrderInbound: WorkOrderInBoundLocate) => {
    getWorkOrderLocateUnknown(workOrderInbound.workOrderId)
  }
  return (
    <div className={classes.container}>
      {workOrderInboundLocate.map((workOrderInbound, index) => (
        <CollapseButton
          header={
            <div>
              <strong>
                {state.unknownFilter === 1 ? `${index + 1}  ` : ''}
              </strong>
              {workOrderInbound.asnNumber}
            </div>
          }
          handleClick={() => handleCollapseClick(workOrderInbound)}
          showButton={true}
        >
          <DetailsDocsMatchPutAway workOrderInboundLocate={workOrderInbound} />
        </CollapseButton>
      ))}

      {workOrderInboundLocate.length === 0 && <WithoutResultsPanel />}
    </div>
  )
}
